import { useMemo } from 'react';

import {
  AdminV1AccountMode,
  useAccountMode,
} from '@spotify/confidence-graphql';

import { type WorkflowExtensionOptions } from '../../extensions';
import { useWorkflowExtensions } from '../useWorkflowExtensions';

export const getCreatableWorkflowExtensions = (
  extensions: WorkflowExtensionOptions[],
  accountMode?: AdminV1AccountMode,
): WorkflowExtensionOptions[] =>
  extensions.filter(
    ext =>
      ext.createDialog &&
      !(accountMode && ext.notCreatableInAccountModes?.includes(accountMode)),
  );

export const useCreatableWorkflowExtensions =
  (): WorkflowExtensionOptions[] => {
    const extensions = useWorkflowExtensions();
    const { isTotalConfidence, isWarehouseNative } = useAccountMode();

    let accountMode: AdminV1AccountMode | undefined;
    if (isTotalConfidence) accountMode = AdminV1AccountMode.TotalConfidence;
    else if (isWarehouseNative)
      accountMode = AdminV1AccountMode.WarehouseNative;

    return useMemo(
      () => getCreatableWorkflowExtensions(extensions, accountMode),
      [extensions, accountMode],
    );
  };
